import LogRocket from 'logrocket';

export const initLogRocket = () => {
  const init = () => {
    LogRocket.init(import.meta.env.VITE_LOGROCKET_API_KEY, {
      release: import.meta.env.VITE_VERSION,
    });
  };

  if (window.location.pathname === '/welcome') {
    setTimeout(init, 5000);
  } else {
    init();
  }
};

const setLogRocketUserData = (accountantId: string) => {
  try {
    LogRocket.identify(accountantId);
  } catch {
    // Sliently fail - non critical
  }
};

export const identifyLogRocketUser = (accountantId: string) => {
  setLogRocketUserData(accountantId);
};

interface CaptureExceptionParams {
  error: Error;
}

export const captureLogRocketException = ({ error }: CaptureExceptionParams) => {
  try {
    LogRocket.captureException(error);
  } catch {
    // Sliently fail - non critical
  }
};

export const getLogRocketSessionURL = (callback: (sessionURL: string) => void) => {
  LogRocket.getSessionURL(callback);
};

type TrackEventProperties = Record<
  string,
  string | number | boolean | string[] | number[] | boolean[] | null | undefined
>;

export const trackLogRocketEvent = (eventName: string, properties?: TrackEventProperties) => {
  try {
    LogRocket.track(eventName, properties);
  } catch {
    // Silently fail — non-critical
  }
};
